module.exports = __webpack_public_path__ + "static/media/modalInfoBG.9b582031.jpg";